import { render } from "./form-group.vue?vue&type=template&id=778d694c"
import script from "./form-group.vue?vue&type=script&lang=js"
export * from "./form-group.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/form-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "778d694c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('778d694c', __exports__)) {
    console.log('reload')
    api.reload('778d694c', __exports__)
  }
  
  module.hot.accept("./form-group.vue?vue&type=template&id=778d694c", () => {
    console.log('re-render')
    api.rerender('778d694c', render)
  })

}


export default __exports__